import { ArrayParam, StringParam } from 'use-query-params';

import { DEFAULT_RANGES } from '@/shared/lib/portfolioFilters';

import { IActorFiltersForm } from './types/User';

/** Дефолтные значения формы фильтров портфолио актёра */
export const defaultFilterValues: IActorFiltersForm = {
  name: '',
  country_ids: [],
  language_ids: [],
  hair_color: [],
  hair_length: [],
  eye_color: [],
  appearance_types: [],
  body_type: [],
  height: DEFAULT_RANGES.height,
  weight: DEFAULT_RANGES.weight,
  chest_girth: DEFAULT_RANGES.chest_girth,
  waist_girth: DEFAULT_RANGES.waist_girth,
  hips_girth: DEFAULT_RANGES.hips_girth,
  age: DEFAULT_RANGES.age,
  top_size: [],
  bottom_size: [],
  work_permissions: [],
  filming_restrictions: [],
  shoe_size: [],
  features: [],
  speech_features: [],
  gender: null,
  experience: null,
  sport_ids: [],
  dance_style_ids: [],
  musical_instrument_ids: [],
  vocal_style_ids: [],
  extra_ids: [],
  job_casting_role_ids: [],
  job_film_ids: [],
  job_project_types: [],
  job_release_years: [],
  job_is_short_film: null
};

/** Конфиг query-параметров фильтров портфолио актёра (use-query-params) */
export const actorFiltersQueryParamsConfig = {
  name: StringParam,
  gender: StringParam,
  country_ids: ArrayParam,
  language_ids: ArrayParam,
  hair_color: ArrayParam,
  hair_length: ArrayParam,
  eye_color: ArrayParam,
  appearance_types: ArrayParam,
  body_type: ArrayParam,
  height: ArrayParam,
  weight: ArrayParam,
  chest_girth: ArrayParam,
  waist_girth: ArrayParam,
  hips_girth: ArrayParam,
  age: ArrayParam,
  top_size: ArrayParam,
  bottom_size: ArrayParam,
  work_permissions: ArrayParam,
  filming_restrictions: ArrayParam,
  shoe_size: ArrayParam,
  features: ArrayParam,
  speech_features: ArrayParam,
  experience: StringParam,
  sport_ids: ArrayParam,
  dance_style_ids: ArrayParam,
  musical_instrument_ids: ArrayParam,
  vocal_style_ids: ArrayParam,
  extra_ids: ArrayParam,
  job_casting_role_ids: ArrayParam,
  job_film_ids: ArrayParam,
  job_project_types: ArrayParam,
  job_release_years: ArrayParam,
  job_is_short_film: StringParam
};
